var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.795,
    viewBox: "0 0 18 17.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_5953096",
    d: "M16.287,8.557,15.242,9.6l-.027.027L8.507,16.337a.563.563,0,0,1-.326.16l-3.631.461a.56.56,0,0,1-.625-.632l.492-3.6a.563.563,0,0,1,.159-.32l6.94-6.94,1.046-1.046.075-.075H1.509A1.51,1.51,0,0,0,0,5.855V19.2a1.51,1.51,0,0,0,1.509,1.509H14.853A1.511,1.511,0,0,0,16.362,19.2V8.482Zm-.08-1.5L8.469,14.791,6.123,12.444l7.738-7.738ZM17,6.261,14.653,3.914l.934-.934a.231.231,0,0,1,.326,0L17.933,5a.231.231,0,0,1,0,.326L17,6.261ZM5.461,13.367l2.082,2.082-2.409.306Z",
    transform: "translate(0 -2.913)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEditIcon);
export default __webpack_public_path__ + "static/media/Profile_edit_Icon.d687d6071b4d2061275c04fa4b6b5523.svg";
export { ForwardRef as ReactComponent };